// @flow
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import RelatedAdsModal from './RelatedAdsModal';
import { hideRelatedAdsPopup } from '../../../actions';
import {
  isRelatedAdsPopupShow,
  getRelatedAdsPopupData,
  getRelateAdsPopupRedirectUrl,
} from '../../../selectors';

type MapDispatchToProps = {
  onModalClose: Function,
};

type MapStateToProps = {
  isShow: boolean,
  relatedAds: Array<Object>,
  redirectUrl: string,
};

function mapDispatchToProps(dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    onModalClose() {
      dispatch(hideRelatedAdsPopup());
    },
  };
}

function mapStateToProps(state: Object): MapStateToProps {
  return {
    isShow: isRelatedAdsPopupShow(state),
    relatedAds: getRelatedAdsPopupData(state),
    redirectUrl: getRelateAdsPopupRedirectUrl(state),
  };
}

const RelatedAdsModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RelatedAdsModal);

export default RelatedAdsModalContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/Modals/RelatedAdsModals/RelatedAdsModalContainer.js